/* Provador Virtual — motor de recomendação + UI de 3 etapas.
   Motor em funções puras (testável em Node); UI só roda no browser. */
(function (root) {
  'use strict';

  /* ============================ MOTOR ============================ */

  // "67-69" | "67–69" | "170+" | "44" | "55*" → [min, max]
  function parseCell(raw) {
    if (raw == null) return null;
    var s = String(raw).replace(/–/g, '-').replace(/[^\d.\-+]/g, '');
    if (!s) return null;
    if (s.indexOf('+') >= 0) {
      var base = parseFloat(s);
      return isNaN(base) ? null : [base, base + 15];
    }
    var parts = s.split('-').filter(Boolean).map(parseFloat);
    if (!parts.length || parts.some(isNaN)) return null;
    return parts.length === 1 ? [parts[0], parts[0]] : [parts[0], parts[parts.length - 1]];
  }

  function parseRow(csv) {
    if (!csv) return null;
    var cells = String(csv).split(',').map(parseCell);
    return cells.some(Boolean) ? cells : null;
  }

  // Tabela crua (CSV vindos da section) → estrutura numérica
  function parseTable(t) {
    var sizes = String(t.sizes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var rows = {};
    ['comprimento', 'largura', 'altura', 'peitoral', 'cintura', 'peso', 'idade'].forEach(function (k) {
      var r = parseRow(t[k]);
      if (r) rows[k] = r;
    });
    // infantil: idade pode vir nos rótulos dos tamanhos ("03-04")
    var sizesAsAges = sizes.length && sizes.every(function (s) { return /^\d{1,2}\s*-\s*\d{1,2}$/.test(s.trim()); });
    if (!rows.idade && sizesAsAges) rows.idade = sizes.map(parseCell);
    var kind = sizesAsAges || /infantil|infantis|kids/i.test(t.title || '') ? 'kids'
      : (rows.peitoral || (rows.altura && !rows.largura)) ? 'body' : 'garment';
    return { id: t.id, title: t.title, sizes: sizes, rows: rows, kind: kind };
  }

  // Antropometria adulto: altura/peso/idade/sexo → circunferências estimadas (cm)
  function estimateBody(p) {
    var h = p.altura, bmi = p.peso / Math.pow(h / 100, 2);
    var fem = p.sexo === 'F';
    var idade = p.idade || 30;
    var peito = fem ? 42 + 2.2 * bmi + 0.1 * (h - 162) : 46 + 2.15 * bmi + 0.15 * (h - 175);
    var cintura = (fem ? 26 + 2.2 * bmi : 34 + 2.2 * bmi) + (fem ? 0.08 : 0.1) * Math.max(0, idade - 30);
    var quadril = fem ? 55 + 1.9 * bmi : 60 + 1.6 * bmi;
    var clamp = function (v) { return Math.round(Math.min(170, Math.max(55, v))); };
    return { peito: clamp(peito), cintura: clamp(cintura), quadril: clamp(quadril) };
  }

  function distToRange(v, range) {
    if (v == null || !range) return null;
    return v < range[0] ? range[0] - v : v > range[1] ? v - range[1] : 0;
  }

  var EASE = { min: 10, max: 20, ideal: 14 }; // folga peça vs. corpo (cm de circunferência)

  // códigos de caimento; a UI traduz
  function fitByEase(ease) {
    if (ease < 4) return 'muitoJusto';
    if (ease < EASE.min) return 'maisJusto';
    if (ease <= EASE.max) return 'ideal';
    if (ease <= EASE.max + 8) return 'maisFolgado';
    return 'muitoFolgado';
  }

  /* ===== diagnóstico por região — FONTE ÚNICA DE VERDADE =====
     Tanto as bolinhas/cores da UI quanto a escolha do tamanho recomendado saem
     daqui. Antes existiam duas lógicas independentes: uma pintava o tórax de
     vermelho ("vai apertar") e a outra recomendava aquele mesmo tamanho como
     "melhor opção". Não repetir esse erro: quem muda regra de caimento mexe SÓ
     nesta função. */
  function classificaFolga(folga, minIdeal, maxIdeal) {
    if (folga < 0) return 'aperta';
    if (folga < minIdeal) return 'justo';
    if (folga <= maxIdeal) return 'ideal';
    return 'folgado';
  }

  /* devolve [{regiao, classe, folga, excesso}] para peito/cintura/quadril do tamanho i.
     folga  > 0 = sobra no corpo (cm de circunferência) · < 0 = aperta
     excesso    = quanto passou do limite do "ideal" (só quando classe = folgado) */
  function diagnosticar(table, profile, i) {
    var rows = table.rows;
    var g = rows.largura && rows.largura[i];
    var larguraPeca = g ? (g[0] + g[1]) : null;   // largura×2 = circunferência da peça

    function porPeca(regiao, medidaCorpo, minIdeal, maxIdeal) {
      if (!larguraPeca || !medidaCorpo) return null;
      var folga = larguraPeca - medidaCorpo;
      return {
        regiao: regiao, classe: classificaFolga(folga, minIdeal, maxIdeal),
        folga: folga, excesso: Math.max(0, folga - maxIdeal),
      };
    }
    // tabela com medidas de CORPO (retrô/infantil): compara direto com a faixa
    function porCorpo(regiao, medidaCorpo, row) {
      var faixa = row && row[i];
      if (!faixa || !medidaCorpo) return null;
      var d = distToRange(medidaCorpo, faixa);
      var acima = medidaCorpo > faixa[1];        // corpo maior que a faixa = a peça aperta
      var classe = d === 0 ? 'ideal' : acima ? (d > 6 ? 'aperta' : 'justo') : (d > 6 ? 'folgado' : 'ideal');
      return {
        regiao: regiao, classe: classe, folga: acima ? -d : d,
        excesso: classe === 'folgado' ? d - 6 : 0,
      };
    }

    return [
      rows.peitoral ? porCorpo('peito', profile.peito, rows.peitoral) : porPeca('peito', profile.peito, 8, 20),
      rows.cintura ? porCorpo('cintura', profile.cintura, rows.cintura) : porPeca('cintura', profile.cintura, 4, 26),
      porPeca('quadril', profile.quadril, 2, 30),
    ];
  }

  /* rótulo do tamanho (muitoJusto/maisJusto/ideal/maisFolgado/muitoFolgado)
     derivado das MEDIDAS. Antes era posicional (distância do índice até o
     recomendado), que era o motivo de um tamanho com as 3 regiões verdes
     aparecer como "Muito folgado". */
  function fitDoDiagnostico(diag) {
    var reg = (diag || []).filter(Boolean);
    if (!reg.length) return null;
    for (var i = 0; i < reg.length; i++) if (reg[i].classe === 'aperta') return 'muitoJusto';
    for (var j = 0; j < reg.length; j++) if (reg[j].classe === 'justo') return 'maisJusto';
    var pior = 0, achou = false;
    for (var k = 0; k < reg.length; k++) {
      if (reg[k].classe === 'folgado') { achou = true; pior = Math.max(pior, reg[k].excesso || 0); }
    }
    if (!achou) return 'ideal';
    return pior > 10 ? 'muitoFolgado' : 'maisFolgado';
  }

  // um tamanho que aperta em qualquer região NÃO serve — não importa o quanto
  // altura/peso "compensem". Não fechar a camisa é eliminatório, não um desconto.
  function aperta(diag) {
    var reg = (diag || []).filter(Boolean);
    for (var i = 0; i < reg.length; i++) if (reg[i].classe === 'aperta') return true;
    return false;
  }

  /* profile: { sexo, altura, peso, idade, peito, cintura, quadril } (peito/cintura/quadril já ajustados nos sliders)
     Retorna { index, perSize, details, aviso } */
  function recommend(table, profile) {
    var n = table.sizes.length;
    if (!n) return null;
    var rows = table.rows;
    var scores = [];

    for (var i = 0; i < n; i++) {
      var parts = [], wsum = 0, score = 0;
      function add(w, d) { if (d != null) { score += w * d; wsum += w; parts.push(d); } }

      if (table.kind === 'kids') {
        add(0.7, distToRange(profile.altura, rows.altura && rows.altura[i]));
        add(0.3, distToRange(profile.idade, rows.idade && rows.idade[i]));
        add(0.15, distToRange(profile.peso, rows.peso && rows.peso[i]));
      } else {
        add(0.4, distToRange(profile.peito, rows.peitoral && rows.peitoral[i]));
        add(0.25, distToRange(profile.altura, rows.altura && rows.altura[i]));
        add(0.2, distToRange(profile.peso, rows.peso && rows.peso[i]));
        add(0.15, distToRange(profile.cintura, rows.cintura && rows.cintura[i]));
        // Linhas de corpo são autoritativas; a folga da peça só entra quando a
        // tabela não tem NADA de corpo (a janela de folga assume corte masculino
        // regular e erra feio em corte slim/babylook).
        if (wsum === 0) {
          if (rows.largura && rows.largura[i]) {
            var g = rows.largura[i];
            var ease = (g[0] + g[1]) - profile.peito; // largura média *2 − peito
            var edge = ease < EASE.min ? EASE.min - ease : ease > EASE.max ? ease - EASE.max : 0;
            score += edge * 2 + Math.abs(ease - EASE.ideal) * 0.3;
            wsum += 1;
          }
          if (rows.comprimento && rows.comprimento[i]) {
            var c = rows.comprimento[i];
            var esperado = profile.altura * (profile.sexo === 'F' ? 0.39 : 0.42);
            score += 0.35 * Math.max(0, Math.abs((c[0] + c[1]) / 2 - esperado) - 3);
            wsum += 0.35;
          }
        }
      }
      scores.push(wsum > 0 ? score / wsum : Infinity);
    }

    /* Diagnóstico de CADA tamanho antes de escolher: a recomendação tem que
       respeitar o mesmo critério que a UI mostra ao cliente. */
    var diags = [];
    for (var k = 0; k < n; k++) diags.push(diagnosticar(table, profile, k));

    function menorScore(idxs) {
      var b = idxs[0];
      for (var q = 1; q < idxs.length; q++) if (scores[idxs[q]] < scores[b] - 1e-9) b = idxs[q];
      return b;
    }

    /* Escolha: (1) apertar é eliminatório — altura e peso não "compensam" um
       tórax que não fecha; (2) entre os que servem, o menor score do fabricante.
       Se nenhum serve, cai no menor score e avisa (corpo fora da grade).

       NÃO ordenar pela janela de folga: ela pressupõe corte masculino regular e
       erra feio em slim (jogador) e babylook (feminina) — testado, derruba 8 dos
       22 casos calibrados. Ela serve pro diagnóstico visual, não pra escolha. */
    var viaveis = [], todos = [];
    for (var v = 0; v < n; v++) { todos.push(v); if (!aperta(diags[v])) viaveis.push(v); }
    var todosApertam = viaveis.length === 0;
    var best = menorScore(todosApertam ? todos : viaveis);

    // avisos como código; a UI traduz (motor não conhece idioma)
    var aviso = null;
    // se NENHUM tamanho fecha, o corpo passou da grade — avisar sempre, e não só
    // quando o escolhido calha de ser o último da lista
    if (todosApertam) aviso = 'MAX';
    else if (best === n - 1 && scores[best] > 1.5) aviso = 'MAX';
    else if (best === 0 && scores[0] > 1.5) aviso = 'MIN';

    /* Rótulo do chip = como aquele tamanho fica EM RELAÇÃO AO RECOMENDADO,
       medido pela folga real no peito. "Ideal" é exclusivo do recomendado: ter
       a mesma palavra em vários chips fazia o cliente ler "melhor opção: G" ao
       lado de "2GG — Ideal" sem ter como entender a diferença. E não é
       posicional (o bug antigo, que chamava de "muito folgado" um tamanho a 2
       posições do recomendado mesmo com todas as regiões boas). */
    function folgaPeito(i) {
      var d = diags[i] && diags[i][0];
      return d ? d.folga : null;
    }
    var fRef = folgaPeito(best);
    var perSize = table.sizes.map(function (s, i) {
      var fit;
      // aperto vem PRIMEIRO: quando o corpo passa da grade inteira, o escolhido
      // é só o menos ruim — carimbá-lo de "ideal" é o bug original de volta
      if (aperta(diags[i])) fit = 'muitoJusto';
      else if (i === best) fit = 'ideal';
      else {
        var fi = folgaPeito(i);
        if (fi == null || fRef == null) {
          var longe = Math.abs(i - best) > 1;
          fit = i < best ? (longe ? 'muitoJusto' : 'maisJusto') : (longe ? 'muitoFolgado' : 'maisFolgado');
        } else {
          var dif = fi - fRef;                                        // cm de circunferência
          fit = dif < 0 ? 'maisJusto' : dif <= 10 ? 'maisFolgado' : 'muitoFolgado';
        }
      }
      return { size: s, score: scores[i], fit: fit, diag: diags[i] };
    });

    // detalhes crus (a UI traduz o rótulo e converte a unidade)
    var details = [];
    function det(chave, valor, tipo, row) {
      if (valor == null || !row || !row[best]) return;
      var d = distToRange(valor, row[best]);
      details.push({ key: chave, valor: valor, tipo: tipo, status: d === 0 ? 'ideal' : d <= 3 ? 'quase' : 'fora' });
    }
    if (table.kind === 'kids') {
      det('altura', profile.altura, 'comp', rows.altura);
      det('idade', profile.idade, 'idade', rows.idade);
    } else {
      det('peito', profile.peito, 'comp', rows.peitoral);
      det('altura', profile.altura, 'comp', rows.altura);
      det('peso', profile.peso, 'peso', rows.peso);
      det('cintura', profile.cintura, 'comp', rows.cintura);
    }
    return { index: best, perSize: perSize, details: details, aviso: aviso };
  }

  var Motor = {
    parseCell: parseCell, parseTable: parseTable, estimateBody: estimateBody,
    recommend: recommend, distToRange: distToRange,
    diagnosticar: diagnosticar, fitDoDiagnostico: fitDoDiagnostico, aperta: aperta,
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Motor; return; }
  root.SizeProvadorMotor = Motor;

  /* ============================ UI ============================ */
  if (typeof document === 'undefined') return;

  var STORE_KEY = 'sizeProvadorPerfil';

  /* ===== textos (a section escolhe o idioma; mesmo asset serve todas as lojas) ===== */
  var I18N = {
    pt: {
      t1: 'Provador Virtual', st1: 'Informe seus dados reais de altura, peso e idade. Com eles calculamos as suas medidas e indicamos o tamanho ideal desta peça.',
      t1k: 'Medidas da criança', st1k: 'Informe a altura, o peso e a idade reais da criança para encontrarmos o tamanho ideal desta peça.',
      altura: 'Altura', peso: 'Peso', idade: 'Idade', sexo: 'Sexo',
      alturaK: 'Altura da criança', pesoK: 'Peso da criança', idadeK: 'Idade da criança',
      anos: 'anos', unPol: 'pol', masc: 'Masculino', proximo: 'Próximo', fechar: 'Fechar',
      pronto: 'Pronto!', prontoSub: 'Confira as medidas e ajuste se precisar', fem: 'Feminino', continuar: 'Continuar',
      t2: 'Ajuste o formato do corpo', st2: 'Estas são as medidas que estimamos a partir dos seus dados. Se você conhece suas medidas reais de tórax, cintura e quadril, ajuste abaixo — quanto mais preciso, melhor a recomendação.',
      peito: 'Tórax', cintura: 'Cintura', quadril: 'Quadril',
      verRec: 'Ver recomendação', voltar: 'Voltar',
      t3: 'Recomendação', melhor: 'Melhor opção', maisProximo: 'Mais próximo', tambemServe: 'Também serve', naoIdeal: 'O ideal para você é o {X}', tapSize: 'Toque em outro tamanho para ver onde aperta ou sobra:',
      selecionar: 'Selecionar', editar: 'Editar medidas',
      verTabela: 'Ver tabela de medidas', verProvador: 'Voltar ao provador', acessoTabela: 'Tabela de Medidas',
      errAltura: 'Confira a altura', errPeso: 'Confira o peso', errIdade: 'Confira a idade',
      semVariante: 'Não encontrei o tamanho equivalente nas opções do produto — selecione manualmente na página.',
      avisoMax: 'Você está no limite do maior tamanho desta linha — pode ficar justo.',
      avisoMin: 'Você está abaixo do menor tamanho desta linha — pode ficar folgado.',
      fit: { muitoJusto: 'Muito justo', maisJusto: 'Mais justo', ideal: 'Ideal', maisFolgado: 'Mais folgado', muitoFolgado: 'Muito folgado' },
      caimentos: { aperta: 'vai apertar', justo: 'justo', ideal: 'ideal', folgado: 'folgado' },
      cai: {
        aperta: function (v, u) { return 'Aperta ' + v + ' ' + u + ' no peito — não fecha bem'; },
        sobra: function (v, u, termo) { return 'Sobra ' + v + ' ' + u + ' no peito — ' + termo; },
        colado: 'colado ao corpo', justo: 'caimento justo', confortavel: 'caimento confortável', solto: 'caimento solto',
        barra: function (onde, v, u) { return 'Barra ' + onde + ' (' + v + ' ' + u + ' de comprimento)'; },
        acima: 'acima da cintura', naCintura: 'na cintura', noQuadril: 'no quadril', abaixo: 'abaixo do quadril',
      },
      linhas: 'Comprimento|Largura — peito|Altura|Peitoral|Cintura|Peso|Idade',
      medida: 'Medida', esteProduto: 'este produto',
    },
    en: {
      t1: 'Virtual Fitting Room', st1: 'Enter your real height, weight and age. We use them to estimate your body measurements and find the right size for this product.',
      t1k: "Child's measurements", st1k: "Enter the child's real height, weight and age so we can find the right size for this product.",
      altura: 'Height', peso: 'Weight', idade: 'Age', sexo: 'Gender',
      alturaK: "Child's height", pesoK: "Child's weight", idadeK: "Child's age",
      anos: 'years', unPol: 'in', masc: 'Male', proximo: 'Next', fechar: 'Close',
      pronto: 'All set!', prontoSub: 'Check your measurements and adjust if needed', fem: 'Female', continuar: 'Continue',
      t2: 'Adjust your body shape', st2: 'These are the measurements we estimated from your details. If you know your real chest, waist and hip measurements, adjust them below — the more accurate, the better the recommendation.',
      peito: 'Chest', cintura: 'Waist', quadril: 'Hips',
      verRec: 'See my size', voltar: 'Back',
      t3: 'Recommendation', melhor: 'Best match', maisProximo: 'Closest size', tambemServe: 'Also fits', naoIdeal: 'Your best match is {X}', tapSize: 'Tap another size to see where it fits tight or loose:',
      selecionar: 'Select', editar: 'Edit measurements',
      verTabela: 'View size chart', verProvador: 'Back to fitting room', acessoTabela: 'Size Chart',
      errAltura: 'Please check the height', errPeso: 'Please check the weight', errIdade: 'Please check the age',
      semVariante: "We couldn't match this size to the product options — please select it manually on the page.",
      avisoMax: "You're at the limit of the largest size in this range — it may feel tight.",
      avisoMin: "You're below the smallest size in this range — it may feel loose.",
      fit: { muitoJusto: 'Very tight', maisJusto: 'Tighter', ideal: 'Best fit', maisFolgado: 'Looser', muitoFolgado: 'Very loose' },
      caimentos: { aperta: 'will be tight', justo: 'snug', ideal: 'ideal', folgado: 'loose' },
      cai: {
        aperta: function (v, u) { return v + ' ' + u + ' too tight across the chest — it won\'t fit well'; },
        sobra: function (v, u, termo) { return v + ' ' + u + ' of room at the chest — ' + termo; },
        colado: 'skin-tight', justo: 'fitted', confortavel: 'comfortable fit', solto: 'loose fit',
        barra: function (onde, v, u) { return 'Hem sits ' + onde + ' (' + v + ' ' + u + ' long)'; },
        acima: 'above the waist', naCintura: 'at the waist', noQuadril: 'at the hips', abaixo: 'below the hips',
      },
      linhas: 'Length|Width — chest|Height|Chest|Waist|Weight|Age',
      medida: 'Measure', esteProduto: 'this product',
    },
  };

  // manequim 3D (mannequin-js ESM) + gsap carregam sob demanda; SVG é o fallback
  var libs3d = null;
  function tem3D() { return !!(root.Provador3D && root.Provador3D.isReady()); }
  function ensure3D() {
    if (tem3D() && root.gsap) return Promise.resolve(true);
    if (libs3d) return libs3d;
    function load(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    libs3d = Promise.all([
      root.gsap ? Promise.resolve() : load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js').catch(function () {}),
      root.Provador3D ? root.Provador3D.ready() : Promise.resolve(false),
    ]).then(function () { return tem3D(); })
      .catch(function () { return false; });
    return libs3d;
  }

  function init(sectionId) {
    var overlay = document.getElementById('sp-overlay-' + sectionId);
    var dataEl = document.querySelector('[data-provador-data="' + sectionId + '"]');
    if (!overlay || !dataEl || overlay.dataset.spUi) return;
    overlay.dataset.spUi = '1';

    var data = JSON.parse(dataEl.textContent);
    var T = I18N[data.locale === 'en' ? 'en' : 'pt'];
    var imperial = !!data.imperial;              // EUA: polegadas/libras por padrão
    var tables = data.tables.map(parseTable);
    var table = tables.filter(function (t) { return t.id === data.detected; })[0] || tables[0];
    if (!table) return;
    var isKids = table.kind === 'kids';
    var sexoDefault = /feminin|women/i.test(table.title || '') ? 'F' : 'M';

    var $ = function (sel) { return overlay.querySelector(sel); };
    var $$ = function (sel) { return [].slice.call(overlay.querySelectorAll(sel)); };

    var state = {
      step: 1,
      sexo: sexoDefault,
      unidadeAltura: imperial ? 'pol' : 'cm', unidadePeso: imperial ? 'lb' : 'kg',
      altura: null, peso: null, idade: null,
      peito: null, cintura: null, quadril: null,
      resultado: null,
    };

    function loadPerfil() {
      try {
        var raw = localStorage.getItem(STORE_KEY);
        if (!raw) return null;
        var p = JSON.parse(raw);
        return p && p[isKids ? 'kids' : 'adulto'] || null;
      } catch (e) { return null; }
    }
    function savePerfil() {
      try {
        var raw = {}; try { raw = JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) {}
        raw[isKids ? 'kids' : 'adulto'] = {
          sexo: state.sexo, altura: state.altura, peso: state.peso, idade: state.idade,
          peito: state.peito, cintura: state.cintura, quadril: state.quadril,
        };
        localStorage.setItem(STORE_KEY, JSON.stringify(raw));
      } catch (e) {}
    }

    /* ---------- silhueta SVG ---------- */
    function smoothPath(pts) {
      var d = 'M ' + pts[0][0] + ' ' + pts[0][1];
      for (var i = 1; i < pts.length; i++) {
        var p0 = pts[i - 1], p1 = pts[i];
        var cy = (p0[1] + p1[1]) / 2;
        d += ' C ' + p0[0] + ' ' + cy + ', ' + p1[0] + ' ' + cy + ', ' + p1[0] + ' ' + p1[1];
      }
      return d;
    }
    function cmToPx(circ) { return circ * 0.36 * 2.2; } // circunferência → largura frontal em px

    // desenha no container: 3D quando disponível, senão SVG
    function renderFigura(nome, medidas, animar) {
      var cont = $('[data-fig="' + nome + '"]');
      if (!cont) return;
      var tinha3d = tem3D();
      var opts = { sexo: state.sexo, kids: isKids, altura: state.altura, peito: state.peito, cintura: state.cintura, quadril: state.quadril, medidas: medidas, peca: pecaDoTamanho() };
      // cores das faixas seguem o tamanho selecionado (verde/amarelo/vermelho/azul)
      if (medidas && state.resultado) {
        opts.cores = diagnosticoRegioes(state.resultado.index).map(function (d) {
          return d ? COR[d.classe] : COR.ideal;
        });
      }
      /* O container do 3D vive no painel esquerdo, FORA das sections [data-step];
         basta ele próprio não estar oculto. (Não usar offsetParent: o tema esconde
         div:empty e o container nasce vazio.) */
      var visivel = !cont.hidden;
      if (tinha3d && visivel) {
        var inst = root.Provador3D.mount(cont);
        if (inst) { inst.resize(); inst.update(opts, animar); return; }
      }
      var svg = cont.querySelector('svg');
      if (!svg) {
        cont.innerHTML = '<svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg"></svg>';
        svg = cont.querySelector('svg');
      }
      drawSilhueta(svg, opts);
      // libs 3D ainda não chegaram: agenda o upgrade pra quando o download terminar
      if (!tinha3d) ensure3D().then(function (ok) { if (ok) figuraAtual(); });
    }

    /* medidas da PEÇA no tamanho selecionado (pra vestir o manequim).
       Só existe em tabela com medidas de peça; sem elas o corpo aparece sem camisa. */
    function pecaDoTamanho() {
      if (state.step !== 3 || !state.resultado) return null;
      var i = state.resultado.index;
      var rows = table.rows;
      function meio(row) { var c = row && row[i]; return c ? (c[0] + c[1]) / 2 : null; }
      var largura = meio(rows.largura);
      if (!largura) return null;
      return { largura: largura, comprimento: meio(rows.comprimento) || 72, cor: state.corProduto || 0x2f6df6 };
    }

    /* Cor de cada faixa do corpo (peito, cintura, quadril) para o tamanho `i`:
       mostra ONDE aperta e ONDE sobra, que é o que o cliente quer enxergar.
       vermelho = aperta · amarelo = justo · verde = ideal · azul = folgado */
    var COR = { aperta: 0xef4444, justo: 0xf59e0b, ideal: 0x22c55e, folgado: 0x3b82f6 };

    /* Delega pro motor: as cores das faixas, os rótulos dos chips e a escolha do
       tamanho recomendado precisam sair TODOS do mesmo cálculo. Havia aqui uma
       cópia desta lógica que divergia do `recommend` — era o que produzia
       "melhor opção" num tamanho com o tórax pintado de vermelho. */
    function diagnosticoRegioes(i) {
      return Motor.diagnosticar(table, {
        peito: state.peito, cintura: state.cintura, quadril: state.quadril,
      }, i);
    }

    /* frase de caimento em cm reais — o que o cliente entende de fato */
    function atualizaCaimento(i) {
      var el = $('[data-res="caimento"]');
      if (!el) return;
      var rows = table.rows;
      var g = rows.largura && rows.largura[i];
      var c = rows.comprimento && rows.comprimento[i];
      var partes = [];
      // exibe na unidade que o cliente escolheu (tabelas são sempre em cm)
      var pol = state.unidadeAltura === 'pol';
      var un = pol ? 'in' : 'cm';
      var conv = function (cmv) { return pol ? Math.round(cmv / 2.54 * 10) / 10 : Math.round(cmv); };

      if (g && state.peito) {
        var folgaCm = (g[0] + g[1]) - state.peito;
        var v = conv(Math.abs(folgaCm));
        if (folgaCm < 0) partes.push(T.cai.aperta(v, un));
        else {
          var termo = folgaCm < 4 ? T.cai.colado : folgaCm < 10 ? T.cai.justo : folgaCm <= 20 ? T.cai.confortavel : T.cai.solto;
          partes.push(T.cai.sobra(v, un, termo));
        }
      }
      if (c && state.altura) {
        var compMedio = (c[0] + c[1]) / 2;
        var cintura = state.altura * 0.60;
        var quadril = state.altura * 0.52;
        var barra = state.altura * 0.845 - compMedio;
        var onde = barra > cintura + 1 ? T.cai.acima
          : barra > quadril + 2 ? T.cai.naCintura
            : barra > quadril - 3 ? T.cai.noQuadril : T.cai.abaixo;
        partes.push(T.cai.barra(onde, conv(compMedio), un));
      }
      el.textContent = partes.join(' · ');
      el.hidden = !partes.length;
    }

    function figuraAtual() {
      if (state.step === 2) renderFigura('corpo', false);
      else if (state.step === 3) renderFigura('corpo', true);
    }

    function drawSilhueta(svg, opts) {
      var fem = opts.sexo === 'F';
      var k = opts.kids ? 0.72 : 1;
      var chest = Math.max(56, cmToPx(opts.peito || 96) + (fem ? 4 : 0)) * k;
      var waist = Math.max(44, cmToPx(opts.cintura || 84)) * k;
      var hip = Math.max(52, cmToPx(opts.quadril || 98)) * k;
      var shoulder = Math.max(chest + (fem ? -2 : 12) * k, (fem ? 76 : 92) * k);
      var C = 100;
      var Y = opts.kids
        ? { neck: 64, shoulder: 80, chest: 112, waist: 150, hip: 178, seat: 196, ankle: 318 }
        : { neck: 44, shoulder: 64, chest: 104, waist: 148, hip: 180, seat: 200, ankle: 330 };

      // tronco (fechado); ponto extra antes do ombro arredonda o trapézio
      var right = [
        [C + 10 * k, Y.neck],
        [C + shoulder / 2 - 7, Y.shoulder - 9],
        [C + shoulder / 2, Y.shoulder],
        [C + chest / 2, Y.chest],
        [C + waist / 2, Y.waist],
        [C + hip / 2, Y.hip],
        [C + hip / 2 - 4, Y.seat],
      ];
      var left = right.map(function (p) { return [2 * C - p[0], p[1]]; }).reverse();
      var lp = smoothPath(left);
      var d = smoothPath(right) + ' L ' + left[0][0] + ' ' + left[0][1] + ' ' + lp.slice(lp.indexOf('C')) + ' Z';

      // pernas separadas (traço grosso com ponta redonda)
      var legW = Math.max(15 * k, hip / 3.6);
      var legX = hip / 4 + 1.5;
      var legs = [1, -1].map(function (s) {
        return '<path d="M ' + (C + s * legX) + ' ' + (Y.hip - 4) + ' Q ' + (C + s * (legX + 1)) + ' ' + ((Y.hip + Y.ankle) / 2) + ' ' + (C + s * (legX - 3)) + ' ' + Y.ankle + '" stroke="#e8e8ea" stroke-width="' + legW + '" stroke-linecap="round" fill="none"/>';
      }).join('');

      // braços com vão em relação ao tronco
      var armW = 11.5 * k;
      var arms = [1, -1].map(function (s) {
        return '<path d="M ' + (C + s * (shoulder / 2 - 2)) + ' ' + (Y.shoulder + 4) + ' Q ' + (C + s * (chest / 2 + 17)) + ' ' + (Y.chest + 18) + ' ' + (C + s * (waist / 2 + 19)) + ' ' + (Y.waist + 42) + '" stroke="#e4e4e7" stroke-width="' + armW + '" stroke-linecap="round" fill="none"/>';
      }).join('');

      var headR = (fem ? 15.5 : 16.5) * k;
      var headCy = Y.neck - headR * 1.16 - 4;
      var neck = '<rect x="' + (C - 7 * k) + '" y="' + (headCy + headR * 0.7) + '" width="' + 14 * k + '" height="' + (Y.neck - headCy) + '" rx="' + 6 * k + '" fill="#e4e4e7"/>';

      var lines = '';
      if (opts.medidas) {
        [[Y.chest, chest], [Y.waist, waist], [Y.hip, hip]].forEach(function (m) {
          var half = m[1] / 2 + 16;
          lines += '<line x1="' + (C - half) + '" y1="' + m[0] + '" x2="' + (C + half) + '" y2="' + m[0] + '" stroke="#16a34a" stroke-width="2"/>' +
            '<circle cx="' + (C - half) + '" cy="' + m[0] + '" r="3" fill="#16a34a"/>' +
            '<circle cx="' + (C + half) + '" cy="' + m[0] + '" r="3" fill="#16a34a"/>';
        });
      }

      svg.innerHTML = legs + arms + neck +
        '<ellipse cx="100" cy="' + headCy + '" rx="' + headR + '" ry="' + headR * 1.16 + '" fill="#e4e4e7"/>' +
        '<path d="' + d + '" fill="#e8e8ea" stroke="#d4d4d8" stroke-width="1"/>' + lines;
    }

    /* ---------- navegação ---------- */
    function fechar() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    var LIM = { peito: [60, 160], cintura: [50, 170], quadril: [55, 175] };
    function setMedida(m, cm) {
      var l = LIM[m] || [40, 180];
      state[m] = Math.round(Math.max(l[0], Math.min(l[1], cm)));
    }

    // arrastar o slider e digitar o número são a mesma coisa: alteram a medida
    overlay.addEventListener('input', function (e) {
      var rng = e.target.closest('[data-range]');
      if (rng) {
        setMedida(rng.getAttribute('data-range'), parseFloat(rng.value));
        renderAjuste();
        return;
      }
      var num = e.target.closest('[data-val]');
      if (num) {
        var v = parseFloat(num.value);
        if (!isNaN(v)) { setMedida(num.getAttribute('data-val'), paraCm(v)); renderAjuste(true); }
      }
    });
    // ao sair do campo, normaliza o que foi digitado (ex.: valor fora do limite)
    overlay.addEventListener('blur', function (e) {
      if (e.target.closest('[data-val]')) renderAjuste();
    }, true);

    // painel esquerdo: 'foto' (etapa 1), 'corpo' (2 e 3) ou 'load' (transição)
    function painel(qual) {
      $$('[data-painel]').forEach(function (el) { el.hidden = el.getAttribute('data-painel') !== qual; });
      if (qual === 'corpo') renderFigura('corpo', state.step === 3, true);
    }

    function show(step) {
      state.step = step;
      $$('[data-step]').forEach(function (el) { el.hidden = el.getAttribute('data-step') !== String(step); });
      $$('.sp-dots span').forEach(function (dot, i) { dot.className = i + 1 === step ? 'on' : ''; });
      $('.sp-body').scrollTop = 0;

      // rodapé: rótulos e visibilidade por etapa
      var voltar = $('[data-acao="voltar"]'), avancar = $('[data-acao="avancar"]');
      voltar.hidden = step === 1;
      avancar.textContent = step === 1 ? T.proximo : step === 2 ? T.verRec : T.selecionar;
      painel(step === 1 ? 'foto' : 'corpo');

      var atual = $('[data-step="' + step + '"]');
      if (root.gsap && atual) {
        root.gsap.fromTo(atual, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.32, ease: 'power2.out', clearProps: 'all' });
      }
    }

    // "Pronto!" antes de mostrar a recomendação
    function transicaoPronto(depois) {
      var load = $('[data-painel="load"]');
      if (!load) return depois();
      $$('[data-painel]').forEach(function (el) { el.hidden = el.getAttribute('data-painel') !== 'load'; });
      // reinicia a animação do anel
      var arco = load.querySelector('.sp-load__arco'), txt = load.querySelector('.sp-load__txt');
      [arco, txt].forEach(function (el) { if (el) { el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; } });
      setTimeout(depois, 1250);
    }

    function showView(name) {
      $$('[data-view]').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
      $('[data-view-toggle]').textContent = name === 'provador' ? T.verTabela : T.verProvador;
      $('.sp-foot__dir').style.visibility = name === 'provador' ? 'visible' : 'hidden';
    }

    /* ---------- etapa 1 ---------- */
    function lerCampos() {
      var alt = parseFloat($('[data-in="altura"]').value);
      var pes = parseFloat($('[data-in="peso"]').value);
      var ida = parseFloat($('[data-in="idade"]').value);
      if (state.unidadeAltura === 'pol') alt = alt * 2.54;
      if (state.unidadePeso === 'lb') pes = pes * 0.4536;
      var lim = isKids ? { a: [70, 185], p: [10, 100], i: [2, 16] } : { a: [130, 220], p: [30, 200], i: [12, 99] };
      // a faixa é mostrada NA UNIDADE ESCOLHIDA — senão o cliente não entende o erro
      var pol = state.unidadeAltura === 'pol', lb = state.unidadePeso === 'lb';
      var fx = function (par, conv, un) {
        return ' (' + Math.round(par[0] / conv) + '–' + Math.round(par[1] / conv) + ' ' + un + ')';
      };
      var erro = null;
      if (!(alt >= lim.a[0] && alt <= lim.a[1])) erro = T.errAltura + fx(lim.a, pol ? 2.54 : 1, pol ? 'in' : 'cm');
      else if (!(pes >= lim.p[0] && pes <= lim.p[1])) erro = T.errPeso + fx(lim.p, lb ? 0.4536 : 1, lb ? 'lb' : 'kg');
      else if (!(ida >= lim.i[0] && ida <= lim.i[1])) erro = T.errIdade + fx(lim.i, 1, T.anos);
      $('[data-erro]').textContent = erro || '';
      if (erro) return false;
      state.altura = Math.round(alt); state.peso = Math.round(pes); state.idade = ida;
      return true;
    }

    function estimar() {
      if (isKids) return;
      var est = estimateBody({ sexo: state.sexo, altura: state.altura, peso: state.peso, idade: state.idade });
      state.peito = est.peito; state.cintura = est.cintura; state.quadril = est.quadril;
    }

    /* ---------- etapa 2 ---------- */
    // valor exibido nos ajustes: cm ou polegadas, conforme a escolha do cliente
    function paraExibir(cm) { return state.unidadeAltura === 'pol' ? Math.round(cm / 2.54) : Math.round(cm); }
    function paraCm(v) { return state.unidadeAltura === 'pol' ? v * 2.54 : v; }

    function renderAjuste(soFigura) {
      ['peito', 'cintura', 'quadril'].forEach(function (m) {
        var inp = $('[data-val="' + m + '"]');
        var rng = $('[data-range="' + m + '"]');
        if (inp && document.activeElement !== inp) inp.value = paraExibir(state[m]);
        if (rng) rng.value = state[m];
      });
      $$('[data-un-medida]').forEach(function (el) { el.textContent = state.unidadeAltura === 'pol' ? 'in' : 'cm'; });
      renderFigura('corpo', false, !soFigura);
    }

    /* ---------- etapa 3 ---------- */
    /* ÚNICO ponto que aplica um tamanho na tela: texto, caimento, legenda e cores
       das faixas saem sempre do mesmo índice — não há como divergirem. */
    function titulo0() { return $('[data-i18n="melhor"]'); }
    function mostrarTamanho(i) {
      if (!state.resultado) return;
      state.resultado.index = i;
      $('[data-res="size"]').textContent = table.sizes[i];
      atualizaCaimento(i);
      renderLegenda(i);
      renderFigura('corpo', true);

      // é o tamanho recomendado ou só "também serve"?
      var ehIdeal = i === state.recomendado;
      /* Se o recomendado APERTA, nenhum tamanho da grade fecha e ele é apenas o
         mais próximo — chamar de "melhor opção" ao lado de "não fecha bem" é a
         mesma contradição que este arquivo já corrigiu na escolha do tamanho. */
      var apertaAqui = Motor.aperta(diagnosticoRegioes(i));
      if (titulo0()) titulo0().textContent = ehIdeal
        ? (apertaAqui ? (T.maisProximo || T.melhor) : T.melhor)
        : T.tambemServe;

      var selo = $('[data-res="selo"]');
      if (selo) {
        selo.className = 'sp-card-size__ok' + (ehIdeal ? '' : ' sp-card-size__ok--nao');
        selo.innerHTML = ehIdeal
          ? '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L19 7"/></svg>'
          : '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
      }

      // aponta o ideal quando o cliente está olhando outro tamanho
      var dica = $('[data-res="dica"]');
      if (dica) {
        dica.textContent = ehIdeal ? '' : T.naoIdeal.replace('{X}', table.sizes[state.recomendado]);
        dica.hidden = ehIdeal;
      }

      // o botão final aplica o tamanho escolhido no produto
      var btn = $('[data-acao="avancar"]');
      if (btn && state.step === 3) btn.textContent = T.selecionar + ' ' + table.sizes[i];
    }

    function renderLegenda(i) {
      var el = $('[data-res="legenda"]');
      if (!el) return;
      var regs = diagnosticoRegioes(i).filter(Boolean);
      if (!regs.length) { el.innerHTML = ''; return; }
      el.innerHTML = regs.map(function (d) {
        return '<span class="sp-leg"><span class="sp-leg__i sp-leg__i--' + d.classe + '"></span>' +
          '<b>' + (T[d.regiao] || d.regiao) + ':</b> ' + (T.caimentos[d.classe] || d.classe) + '</span>';
      }).join('');
    }

    function renderResultado() {
      var r = recommend(table, state);
      state.resultado = r;
      if (!r) return;
      state.recomendado = r.index;   // referência fixa: qual é o ideal
      $('[data-res="size"]').textContent = table.sizes[r.index];
      $('[data-res="tabela"]').textContent = table.title;
      $('[data-erro3]').textContent = r.aviso ? (r.aviso === 'MAX' ? T.avisoMax : T.avisoMin) : '';

      var alt = $('[data-res="outros"]');
      alt.innerHTML = r.perSize.map(function (p, i) {
        var ideal = i === r.index ? '<span class="sp-chip__ok"><svg viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L19 7"/></svg></span>' : '';
        return '<button type="button" class="sp-chip' + (i === r.index ? ' sp-chip--on' : '') + '" data-chip="' + i + '">' + ideal +
          '<b>' + p.size + '</b><small>' + (T.fit[p.fit] || p.fit) + '</small></button>';
      }).join('');

      mostrarTamanho(r.index);
      savePerfil();
    }

    function normalizaTamanho(s) {
      return String(s).toLowerCase().replace(/anos?|\s/g, '').replace(/(^|-)0+(\d)/g, '$1$2');
    }
    function selecionarVariante(size) {
      var alvo = normalizaTamanho(size);
      var inputs = [].slice.call(document.querySelectorAll('.product-form__input--size input[type="radio"], fieldset.product-form__input--pill input[type="radio"]'));
      var achou = inputs.filter(function (i) { return normalizaTamanho(i.value) === alvo; })[0];
      // grade infantil que não bate com as variantes (ex.: tabela "16..28" x variantes "8 Years"):
      // casa pela linha de IDADE da tabela, que é a referência comum entre as duas grades.
      if (!achou && table.kind === 'kids' && table.rows.idade) {
        var idx = table.sizes.indexOf(String(size));
        var fx = idx >= 0 ? table.rows.idade[idx] : null;
        if (fx) {
          var alvoIdade = (fx[0] + fx[1]) / 2;
          var porIdade = inputs
            .map(function (i) { return { input: i, n: parseFloat(String(i.value).replace(',', '.')) }; })
            .filter(function (c) { return !isNaN(c.n) && c.n > 0 && c.n <= 20; })
            .sort(function (a, b) { return Math.abs(a.n - alvoIdade) - Math.abs(b.n - alvoIdade); });
          if (porIdade.length) achou = porIdade[0].input;
        }
      }
      if (!achou) {
        // tamanho por faixa (infantil "06-07") vs variante numérica ("6")
        var faixa = parseCell(size);
        if (faixa) {
          var candidatos = inputs
            .map(function (i) { return { input: i, n: parseFloat(normalizaTamanho(i.value)) }; })
            .filter(function (c) { return !isNaN(c.n) && c.n >= faixa[0] - 0.01 && c.n <= faixa[1] + 0.01; })
            .sort(function (a, b) { return a.n - b.n; });
          if (candidatos.length) achou = candidatos[0].input;
        }
      }
      if (achou) { achou.click(); return true; }
      return false;
    }

    /* ---------- eventos ---------- */
    overlay.addEventListener('click', function (e) {
      var t = e.target.closest('[data-acao], [data-chip], [data-un], [data-sexo], [data-view-toggle]');
      if (!t) return;

      if (t.hasAttribute('data-view-toggle')) {
        showView($('[data-view="tabela"]').hidden ? 'tabela' : 'provador');
        return;
      }
      if (t.hasAttribute('data-un')) {
        var grupo = t.getAttribute('data-un-grupo'), un = t.getAttribute('data-un');
        var campo = grupo === 'altura' ? 'unidadeAltura' : 'unidadePeso';
        if (state[campo] === un) return;
        var inp = $('[data-in="' + grupo + '"]'), v = parseFloat(inp.value);
        if (!isNaN(v)) {
          if (grupo === 'altura') inp.value = un === 'pol' ? Math.round(v / 2.54) : Math.round(v * 2.54);
          else inp.value = un === 'lb' ? Math.round(v / 0.4536) : Math.round(v * 0.4536);
        }
        state[campo] = un;
        $$('[data-un-grupo="' + grupo + '"]').forEach(function (b) { b.classList.toggle('sp-un--on', b === t); });
        return;
      }
      if (t.hasAttribute('data-sexo')) {
        state.sexo = t.getAttribute('data-sexo');
        $$('[data-sexo]').forEach(function (b) { b.classList.toggle('sp-seg--on', b === t); });
        return;
      }
      if (t.hasAttribute('data-chip')) {
        var i = parseInt(t.getAttribute('data-chip'), 10);
        $$('[data-chip]').forEach(function (c) { c.classList.toggle('sp-chip--on', c === t); });
        mostrarTamanho(i);
        return;
      }

      var acao = t.getAttribute('data-acao');

      // navegação única no rodapé (padrão da referência)
      if (acao === 'avancar') {
        if (state.step === 1) {
          if (!lerCampos()) return;
          estimar();
          if (isKids) { transicaoPronto(function () { show(3); renderResultado(); }); }
          else { show(2); renderAjuste(); }
        } else if (state.step === 2) {
          transicaoPronto(function () { show(3); renderResultado(); });
        } else {
          // etapa 3: aplica o tamanho escolhido e fecha
          var escolhido = table.sizes[state.resultado ? state.resultado.index : 0];
          if (!selecionarVariante(escolhido)) $('[data-erro3]').textContent = T.semVariante;
          fechar();
        }
        return;
      }
      if (acao === 'voltar') {
        show(state.step === 3 ? (isKids ? 1 : 2) : 1);
        if (state.step === 2) renderAjuste();
        return;
      }
      if (acao === 'mais' || acao === 'menos') {
        var m = t.getAttribute('data-medida');
        state[m] = Math.max(40, Math.min(180, state[m] + (acao === 'mais' ? 1 : -1)));
        renderAjuste();
      }
      if (acao === 'selecionar') {
        if (selecionarVariante(t.dataset.size)) {
          fechar();
        } else {
          $('[data-erro3]').textContent = T.semVariante;
        }
      }
    });

    /* ---------- textos do idioma ---------- */
    function texto(sel, valor) { var el = $(sel); if (el) el.textContent = valor; }
    texto('[data-t1]', T.t1); texto('[data-st1]', T.st1);
    texto('[data-label="altura"]', T.altura); texto('[data-label="peso"]', T.peso); texto('[data-label="idade"]', T.idade);
    texto('[data-i18n="anos"]', T.anos);
    texto('[data-un="pol"]', T.unPol);
    texto('[data-i18n="sexo"]', T.sexo);
    texto('[data-sexo="M"]', T.masc); texto('[data-sexo="F"]', T.fem);
    texto('[data-i18n="t2"]', T.t2); texto('[data-i18n="st2"]', T.st2);
    texto('[data-i18n="peito"]', T.peito); texto('[data-i18n="cintura"]', T.cintura); texto('[data-i18n="quadril"]', T.quadril);
    texto('[data-acao="voltar"]', T.voltar);
    texto('[data-i18n="melhor"]', T.melhor);
    texto('[data-i18n="pronto"]', T.pronto); texto('[data-i18n="prontoSub"]', T.prontoSub);
    texto('[data-i18n="tapSize"]', T.tapSize);

    /* ---------- estado inicial ---------- */
    if (isKids) {
      $('[data-campo="sexo"]').hidden = true;
      texto('[data-t1]', T.t1k); texto('[data-st1]', T.st1k);
      texto('[data-label="altura"]', T.alturaK);
      texto('[data-label="peso"]', T.pesoK);
      texto('[data-label="idade"]', T.idadeK);
      $('.sp-dots').classList.add('sp-dots--2');
    }
    $$('[data-sexo]').forEach(function (b) { b.classList.toggle('sp-seg--on', b.getAttribute('data-sexo') === state.sexo); });
    // botões de unidade refletem o padrão da loja (imperial nos EUA)
    $$('[data-un-grupo="altura"]').forEach(function (b) { b.classList.toggle('sp-un--on', b.getAttribute('data-un') === state.unidadeAltura); });
    $$('[data-un-grupo="peso"]').forEach(function (b) { b.classList.toggle('sp-un--on', b.getAttribute('data-un') === state.unidadePeso); });
    if (imperial) {
      var PH = { altura: '69', peso: '165', idade: '30' };
      Object.keys(PH).forEach(function (k) { var el = $('[data-in="' + k + '"]'); if (el) el.placeholder = PH[k]; });
    }

    // cor dominante da foto do produto → cor da camisa vestida no manequim
    (function corDoProduto() {
      if (!data.produtoImagem) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var cv = document.createElement('canvas');
          cv.width = cv.height = 40;
          var ctx = cv.getContext('2d');
          ctx.drawImage(img, 0, 0, 40, 40);
          var px = ctx.getImageData(10, 8, 20, 22).data; // faixa do torso, evita fundo/borda
          var r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < px.length; i += 4) {
            if (px[i + 3] < 200) continue;
            if (px[i] > 238 && px[i + 1] > 238 && px[i + 2] > 238) continue; // fundo branco
            r += px[i]; g += px[i + 1]; b += px[i + 2]; n++;
          }
          if (!n) return;
          state.corProduto = ((r / n) << 16 | (g / n) << 8 | (b / n) | 0) & 0xffffff;
          if (state.step === 3) renderFigura('corpo', false);
        } catch (e) { /* canvas tainted: mantém a cor padrão */ }
      };
      img.src = data.produtoImagem;
    })();

    var salvo = loadPerfil();
    if (salvo && salvo.altura) {
      state.sexo = salvo.sexo || state.sexo;
      state.altura = salvo.altura; state.peso = salvo.peso; state.idade = salvo.idade;
      state.peito = salvo.peito; state.cintura = salvo.cintura; state.quadril = salvo.quadril;
      $('[data-in="altura"]').value = salvo.altura;
      $('[data-in="peso"]').value = salvo.peso;
      $('[data-in="idade"]').value = salvo.idade;
      $$('[data-sexo]').forEach(function (b) { b.classList.toggle('sp-un--on', b.getAttribute('data-sexo') === state.sexo); });
      if (!state.peito && !isKids) estimar();
      show(3);
      renderResultado();
    } else {
      show(1);
    }
    showView('provador');

    // 1º clique no botão da PDP dispara o download das libs 3D e faz o upgrade da figura
    document.addEventListener('click', function (e) {
      var gatilho = e.target.closest('[data-provador-open]');
      if (!gatilho) return;
      // o botão "Tabela de Medidas" abre direto na aba da tabela
      showView(gatilho.hasAttribute('data-abrir-tabela') ? 'tabela' : 'provador');
      ensure3D().then(function (ok) { if (ok) figuraAtual(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    [].slice.call(document.querySelectorAll('[data-provador-overlay]')).forEach(function (el) {
      init(el.id.replace('sp-overlay-', ''));
    });
  });
  root.SizeProvadorInit = init;
})(typeof window !== 'undefined' ? window : globalThis);
